import React from 'react';
import { Card, Icon } from '../components/ui';
import { getThemePref, setThemePref } from '../theme/themePref';
import './setup/setup.css';

/*
 * DisplaySettings — the "Display" nav screen.
 * One real, per-device setting: the light/dark Theme toggle. It writes
 * `gw-theme` to localStorage and sets document.documentElement.dataset.theme
 * (index.js reads gw-theme on boot).
 *
 * NOTE: accountType is deliberately NOT set here. It is a GateSubscriber-level
 * property, provisioned by the Dividia super-user on the Subscribers screen — a
 * local admin must never see or change it. It reaches the frontend via the login
 * payload and only gates which nav / Setup hierarchy is shown (see AppShell).
 */
class DisplaySettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = { theme: getThemePref() };  // 'light' | 'dark' | 'system'
  }

  setTheme = (theme) => {
    setThemePref(theme);   // persists the choice + applies (resolving 'system' to the OS palette)
    this.setState({ theme });
  };

  render() {
    const { theme } = this.state;
    return (
      <div className="display-screen">
        <Card title="Appearance" subtitle="Personalize how GateWatcher looks on this device." pad>
          <div className="setting-row">
            <div className="grow">
              <strong>Theme</strong>
              <small>Light, dark, or follow your device&rsquo;s setting. Saved to this browser.</small>
            </div>
            <div className="segmented" role="group" aria-label="Theme">
              <button type="button" className={theme === 'light' ? 'on' : ''} onClick={() => this.setTheme('light')}>
                <Icon name="sun" size={15} /> Light
              </button>
              <button type="button" className={theme === 'dark' ? 'on' : ''} onClick={() => this.setTheme('dark')}>
                <Icon name="moon" size={15} /> Dark
              </button>
              <button type="button" className={theme === 'system' ? 'on' : ''} onClick={() => this.setTheme('system')}>
                <Icon name="monitor" size={15} /> System
              </button>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

export default DisplaySettings;
